import React from "react";
import { Redirect } from "react-router-dom";

import { withFirebaseAuth } from "js/react/views/Auth/FirebaseAuthContext";
import { withGoogleAuth } from "js/react/views/Auth/GoogleAuthContext";
import { LoadingPage } from "js/react/components/LoadingPage";
import ErrorMessage from "js/app/ErrorMessage";
import { serverContext } from "js/config";
import logger from "js/core/logger";

const log = logger.info(logger.AUTH).bind(logger);

class SsoConsume extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            status: serverContext.customToken ? "pending" : "failed"
        };
    }

    async componentDidMount() {
        const { auth, auth2 } = this.props;
        try {
            await signOutIfNeeded(auth, auth2);
            await auth.signInWithCustomToken(serverContext.customToken);
            this.setState({ status: "succeeded" });
        } catch (err) {
            this.setState({ status: "failed" });
        }
    }

    render() {
        switch (this.state.status) {
            case "pending":
                return (
                    <LoadingPage />
                );
            case "succeeded":
                return (
                    <Redirect to={serverContext.relayState || "/"} />
                );
            case "failed":
                return (
                    <ErrorMessage message={"Sorry, we could not authenticate you."} />
                );
        }
    }
}

async function signOutIfNeeded(auth, auth2) {
    // sign out of google
    if (auth2.isSignedIn.get()) {
        log("will sign out of google");
        await auth2.signOut();
        log("did sign out of google");
    }

    // sign out of firebase
    if (auth.currentUser) {
        log("will sign out of firebase");
        await auth.signOut();
        log("did sign out of firebase");
    }
}

export default withGoogleAuth(withFirebaseAuth(SsoConsume));
